"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utilities/core/cn";
export function PillTabs(t0) {
  const $ = _c(9);
  const {
    options,
    activeId,
    onChange
  } = t0;
  let t1;
  if ($[0] !== activeId || $[1] !== onChange || $[2] !== options) {
    let t2;
    if ($[4] !== activeId || $[5] !== onChange) {
      t2 = option => <button key={option.id} onClick={() => onChange(option.id)} className={cn("px-3 py-1.5 text-xs font-medium rounded-full whitespace-nowrap transition-colors cursor-pointer", activeId === option.id ? "bg-foreground/10 text-foreground" : "text-muted-foreground hover:text-foreground hover:bg-foreground/5")}>{option.label}</button>;
      $[4] = activeId;
      $[5] = onChange;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = options.map(t2);
    $[0] = activeId;
    $[1] = onChange;
    $[2] = options;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <div className="flex gap-1.5 overflow-x-auto scrollbar-hide py-3">{t1}</div>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}